module.exports = __webpack_public_path__ + "img/vincicarWxPublic.95655b2e.png";